import SocialPartners from "./SocialPartners";

export default SocialPartners;
